export default "__VITE_ASSET__15a0f770__"